import { RA } from "@scripts/fp-ts";
import type { PageU } from "@scripts/generated/domaintables/pages";
import type { PageConfig } from "@scripts/generated/models/pageConfig";
import { tagEq } from "@scripts/util/compare";


export const getPage = <P extends PageU>(page: P) =>
  RA.findFirst((_: PageConfig<PageU>): _ is PageConfig<P> => tagEq().equals(page, _.page));
